import React from 'react';
import './AnimationBar.scss'

const AnimationBar = () => {
    return (
        <div className='bar'>

        </div>
    );
};

export default AnimationBar;